import { Box, IconOptions } from '@jfs/ui-new'
import { FC, ReactElement } from 'react'
import { FlatList } from 'react-native'
import Tab, { TabState, TabType } from '../Tab'
import styles from './styles'
import { TabData, TabbarProps, TabbarType } from './types'

const keyExtractor = (item: TabData): string => {
  return item.title
}

const cellView = (
  {
    index,
    item,
  }: {
    index: number
    item: TabData
  },
  type: TabbarType,
  defaultIndex: number,
  onSelected: any,
  disabled: boolean,
  onLayout: any,
): ReactElement => {
  return (
    <Box {...styles[type].tab}>
      <Tab
        iconId={item?.iconId as unknown as IconOptions}
        title={item.title}
        state={index === defaultIndex ? TabState.selected : TabState.normal}
        type={TabType[type]}
        onSelected={(): void => onSelected(index)}
        isDisabled={disabled}
        onLayout={onLayout}
      />
    </Box>
  )
}

const Tabbar: FC<TabbarProps> = ({
  titles,
  onSelected,
  default: defaultIndex = 1,
  type = TabbarType.default,
  hide = false,
  disabled = false,
  onLayout,
  onLayoutOnlyForPosition,
}: TabbarProps) => {
  const cellRenderor = ({ index, item }: { index: number; item: TabData }): ReactElement => {
    return cellView(
      { index, item },
      type,
      defaultIndex,
      onSelected,
      disabled,
      !onLayoutOnlyForPosition || onLayoutOnlyForPosition === index ? onLayout : undefined,
    )
  }

  const SeparatorComponent = () => {
    return <Box {...styles[type].seperator} />
  }

  const getOpacity = () => {
    return disabled ? { opacity: 0.4 } : {}
  }
  if (hide) {
    return null
  } else {
    return (
      <FlatList
        keyExtractor={keyExtractor}
        renderItem={cellRenderor}
        data={titles}
        horizontal
        ItemSeparatorComponent={SeparatorComponent}
        extraData={defaultIndex}
        style={[styles[type].container, getOpacity()]}
      />
    )
  }
}
export { TabbarType }
export default Tabbar
